
document.addEventListener("DOMContentLoaded", function () {
  let selector = document.querySelector('.product-card__variant-selector');

  if (selector) {
    selector.addEventListener('change', handle);
    handle({ currentTarget: selector }); // ✅ Initial setup
  } else {
    console.warn('.product-card__variant-selector not found.');
  }

 function handle(e) {
  const wrapper = e.currentTarget; // the element with the event listener
  console.log(wrapper, 'this');

  // Get selected option values
  const selectedOptions = Array.from(wrapper.querySelectorAll('select')).map(el => el.value);
  console.log(selectedOptions, 'selectedOptions');

  // Get product variant JSON data
  const productDataEl = wrapper.querySelector('[type="application/json"]');
  if (!productDataEl) {
    console.warn('Product data not found');
    return;
  }

  let variantData;
  try {
    variantData = JSON.parse(productDataEl.textContent);
  } catch (err) {
    console.error('Failed to parse product data JSON', err);
    return;
  }

  // Find the matching variant
  const currentVariant = variantData.find(variant =>
    variant.options.every((option, index) => option === selectedOptions[index])
  );

  if (!currentVariant) {
    console.warn('No matching variant found');
    return;
  }

  console.log(currentVariant, '✅ Matching variant');

  const productForm = wrapper.closest('.product-card')?.querySelector('.product-sample_form');
  const input = productForm?.querySelector('input[name="id"]');
  const currencyFormat = window.moneyformat;

  // Update price
  const priceEl = document.querySelector('.sample-sale-price .new-price');
  if (priceEl && typeof formatMoney === 'function') {
    priceEl.innerText = formatMoney(currentVariant.price, currencyFormat);
  }

  // Update image
  const img_smpl = document.querySelector('.sample_prt_img');
  if (img_smpl && currentVariant.featured_image?.src) {
    img_smpl.src = currentVariant.featured_image.src;
  }

  // Update button state
  const crt_btn = document.querySelector('.sample-prt-adct');
  const crt_btn_text = crt_btn?.querySelector('span');
  if (crt_btn && crt_btn_text) {
    if (!currentVariant.available) {
      crt_btn_text.innerText = 'Sold out';
      crt_btn.disabled = true;
    } else {
      crt_btn_text.innerText = 'Add To Cart';
      crt_btn.disabled = false;
    }
  }

  // Update hidden input
  if (input) {
    input.value = currentVariant.id;
  } else {
    console.warn('Hidden input[name="id"] not found.');
  }
}


function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || "{{amount}}";

    function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number == null) return 0;

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}



const cartButton = document.querySelector('.sample-prt-adct');

  if(cartButton){
cartButton.addEventListener('click', checkCart);
}

async function checkCart(e) {
  try {
    e.preventDefault();
    const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
    const cartData = await cartResponse.json();
    console.log(cartData, 'cartData');

    const targetId = 7857190568006;
    const productForm = document.querySelector('.product-sample_form');
    const variantId = productForm.querySelector('input[name="id"]').value;

    const matchingItems = cartData.items.filter(item => item.product_id === targetId);
    const totalQuantity = matchingItems.reduce((sum, item) => sum + item.quantity, 0);
    const matchingVariant = matchingItems.some(item => item.variant_id == variantId);

    const submitButton = productForm.querySelector("button[type='submit']");
    const button = productForm.querySelector('.sample-prt-adct');
    const message = productForm.querySelector('.sample-notification');

    if (totalQuantity >= 5) {
      message.innerText = "You reached your limit";
      button.after(limitMessage);
        message.classList.remove('hidden');
    } else {
      if (matchingVariant) {
        message.innerText = "You can't add the same variant twice";
        message.classList.remove('hidden');
      } else {
        message.classList.add('hidden');
        submitButton.dispatchEvent(new Event('change', { bubbles: true }));
        submitButton.click();        
      }
    }

    console.log(`Total quantity of product ID ${targetId}:`, totalQuantity);
  } catch (error) {
    console.error('Error checking cart contents:', error);
  }
}



});
